<!-- 底部 - 操作面板 -->
<template>
    <div class="pub-panel-down" @click.self="closePanel">
        <div class="pub-panel-down-wrap" :class="[cacheIsShowCont ? 'slide-in' : 'slide-out',
        {'transparent':contStyleType==0}]">
            <div class="pub-panel-down-head" v-if="isShowHead">
                <span class="btn-cancel" @click="closePanel">取消</span>
                <p class="head-title" v-if="panelTitle">{{panelTitle}}</p>
                <span class="btn-sure" @click="surePanel">确定</span>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<style>
.pub-panel-down{
    width: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
}
.pub-panel-down-wrap{
    width: 100%;
    max-height: 100%;
    background-color: #ffffff;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: all 0.5s ease;
    transform: translateY(100%);
}
.pub-panel-down-wrap.transparent{
    background-color: transparent;
}
.pub-panel-down-wrap.slide-in{
    animation: slideInToUp 0.5s 1 ease;
    animation-delay: 0s;
    animation-fill-mode: forwards;
}
.pub-panel-down-wrap.slide-out{
    animation: slideOutToDown 0.5s 1 ease;
    animation-delay: 0s;
    animation-fill-mode: forwards;
}
.pub-panel-down-head{
    width: 92%;
    height: 0.5rem;
    padding: 0.1rem 4%;
    background-color: #F4F5F6;
    border-bottom: 1px solid #b5b6b6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 0.28rem;
}
.pub-panel-down-head .btn-cancel{
    flex: 0 0 auto;
    margin-right: 0.3rem;
    text-align: left;
    color: #6a6f71;
}
.pub-panel-down-head .btn-sure{
    flex: 0 0 auto;
    margin-left: 0.3rem;
    text-align: right;
    color: #ea531a;
}
.pub-panel-down-head .head-title{
    flex: 1 1 auto;
    text-align: center;
    color: #231815;
}
</style>
<script>
export default {
    props: {
        isShowHead: { //是否显示面板头
            type: Boolean,
            default: true
        },
        panelTitle: { //面板标题
            type: String,
            default: ""
        },
        isShowCont: { //是否显示面板内容
            type: Boolean,
            default: false
        },
        contStyleType: { //面板内容风格: 0:透明背景, 1:白色背景
            type: Number,
            default: 1
        },
    },
	data () {
		return {
			cacheIsShowCont: false,
		}
    },
    mounted(){
        this.cacheIsShowCont = this.isShowCont;
    },
    watch: {
        isShowCont(){
            this.cacheIsShowCont = this.isShowCont;
        },
    },
	methods: {
        surePanel(){
            this.$emit("surePanel");
        },
        closePanel() {
            this.$emit("closePanel");
        },
	}
}
</script>


// WEBPACK FOOTER //
// src/shared/components/control/panel-down.vue